import RestClient from "@leanspace/js-client/dist/RestClient";
import {Page} from "@leanspace/js-client/dist/types/Generic";
import qs from "query-string";

import {CreateLicenseCommand, FindLicensesCommand, License, LicenseJwt} from "../../Types/licenses";

export default class LicensesClient {

  constructor(private http: RestClient) {
  }

  async downloadLicense(id: string): Promise<LicenseJwt> {
    return await this.http.load(`/licenses/licenses/${id}/_download`);
  }

  async searchLicenses(query: FindLicensesCommand): Promise<Page<License>> {
    return await this.http.load(`/licenses/licenses?${qs.stringify({
      ...query,
      query: query.query ? `.*${query.query}.*` : undefined
    })}`);
  }

  async createLicense(command: CreateLicenseCommand): Promise<License> {
    return await this.http.load(`/licenses/licenses`, "POST", command);
  }

  async deleteLicense(id: string, acknowledged?: boolean): Promise<void> {
    return await this.http.load(`/licenses/licenses/${id}?acknowledged=${acknowledged || false}`, "DELETE");
  }

}
